// Takes an input string and breaks it up into words
// If all of those words can be found in option, returns true, otherwise false
// Case in-sensitive
// The order is VERY important, make sure the user-provided text input is the second param 'input'
const smartFilter = (option, input) => {
  // if (typeof option !== 'string') {
  //   return option;
  // }
  const words = input.split(' ');

  return words.reduce(
    (acc, cur) => acc && option.toLowerCase().includes(cur.toLowerCase()),
    true,
  );
};

export default smartFilter;
